const questionModule = {
  title: "登录帮助",
  question1: "我的账户登录密码忘记了怎么办？",
  answer1: "您可以点击*，验证身份后即可重新设置新的登录密码。",
  question2: "登录的手机号不能用了该怎么办？",
  answer2: "请点击下方的*联系Paymul事务局。",
  kefu: "没找到相关问题？点击*",
  linkKefu: "咨询客服",
  returnPassword: "找回密码",
  help1: "无法正常登陆。",
  helpContent1: `登陆Paymul时，您需要确认使用条款和个人信息处理规范，再输入注册时使用手机号和密码进行登陆。新注册用户需使用可接收SMS短信的手机进行注册。如忘记密码，请点击登陆界面的「忘记密码」，并输入手机号重新设置密码。<br/>
   ※输入框末尾有空格的话可能无法登陆。<br/>
   ※如还是无法解决，请在「咨询」处进行反馈。`,
  help2: "如何设定送货地址？",
  helpContent2: `A.注册完成后，自动定位用户的所在地。如定位地址不准确，也可手动进行设定。登陆后若想修改收货地址，可在「我的」→「我的地址」里修改。`,
  help3: "都支持一些什么样的支付方法呢？",
  helpContent3:
    "根据各个店铺会发生变化。请点击你想要查看的店铺，在店铺详情里显示有该店铺支持的支付方法。另外，在「搜索」里可根据支付方法进行店铺的筛选。",
  help4: "我想要切换App的语言。",
  helpContent4: "登陆后点击主页右上角的地球图标，可切换语言。",
  help5: "搜索店铺名后显示空白。",
  helpContent5:
    "用户正在搜索的店铺还未成为Paymul的加盟店。我司计划扩大加盟店规模，如有加盟意愿欢迎前来咨询。关于加盟的申请请通过<a href='info@127jp.com'>info@127jp.com咨询。</a>",
  help6: "以前去过的一家店还想再去，但是忘记了店名。",
  helpContent6: `用户在一家店消费后，在订单内可确认店铺信息。另外，点击店铺页面的右上角的♡，可将该店铺加入收藏夹。之后在「我的收藏」里可以查看已收藏的店铺。`,
  help7: "送达的商品与实际订单不符／商品未送达",
  helpContent7: `请直接与该店铺联络。<br> ※点击店铺详情右上角的电话按钮，可与店家进行电话沟通。`,
  help8: "我想取消订单。",
  helpContent8: `请直接与该店铺联络。点击店铺详情右上角的电话按钮，可与店家进行电话沟通。<br/>
  ※特定店铺或运送情况下可能无法取消订单。`,
  help9: "送货到达时本人不在。",
  helpContent9: "请点击店铺详情右上角的电话按钮，直接与店铺联络。",
  help10: "下单的具体流程是什么？",
  helpContent10: `１）打开店铺页面后，可选择「外卖」「自提」「线上贩卖」，再进行下单。<br/>
  ２）下单后，在订单页面可查看订单状态。显示「已确认」，表示店家已经接单，并在准备菜品。<br/>
  ３）店家准备好菜品并移交给外卖员以后，订单状态会变成「送货中」。<br/>
  ４）订单送货完成后，订单详情页面下方会显示「确认收货」的按钮。如未显示按钮，请重新加载页面。<br/>
  ５）用户确认商品，并点击「确认收货」按钮后，订单即将完成，进入店家确认收款的流程。<br/>
  ６）店家确认收款后，用户即可在订单详情页面进行评论。`
};
export default questionModule;
